//example <div data-bind="drag: {value: exampleValue, classes: {draggable: 'test-Draggable', helper: 'test-Helper', droppable: 'test-Droppable'} }"></div>
import ko from "knockout";
import $ from "jquery";
import register from "flow/knockout/register";

let dragged: any;
register.registerKnockoutBinding("drag", {
    init: function (element, valueAccessor) {
        const dragElement = $(element);
        if (valueAccessor().classes && valueAccessor().classes.draggable) {
            dragElement.addClass(valueAccessor().classes.draggable);
        }
        dragElement.addClass("lc-draggable");
        const dragOptions = {
            helper: function (event: any, _ui: any) {
                const clone = $(event.currentTarget).clone();
                if (valueAccessor().classes && valueAccessor().classes.helper) {
                    clone.addClass(valueAccessor().classes.helper);
                }
                clone.addClass("lc-draggable-helper");
                return clone;
            },
            revert: true,
            revertDuration: 0,
            cursorAt: { top: 0, left: 5 },
            start: function (_event: any, _ui: any) {
                dragged = ko.utils.unwrapObservable(valueAccessor().value);
            }
        };
        dragElement.draggable(dragOptions);
    }
});

register.registerKnockoutBinding("drop", {
    init: function (element, valueAccessor) {
        const dropElement = $(element);
        if (valueAccessor().classes && valueAccessor().classes.droppable) {
            dropElement.addClass(valueAccessor().classes.droppable);
        }
        dropElement.addClass("lc-droppable");
        const dropOptions = {
            hoverClass:
                valueAccessor().classes && valueAccessor().classes.hover
                    ? valueAccessor().classes.hover
                    : "lc-droppable-hover",
            tolerance: "pointer",
            drop: function (_event: any, _ui: any) {
                if (valueAccessor().addToCurrentElement) {
                    const resultVal = parseFloat(valueAccessor().value()) + parseFloat(dragged);
                    valueAccessor().value(resultVal.toFixed(2));
                } else {
                    valueAccessor().value(dragged);
                }
            }
        };
        dropElement.droppable(dropOptions);
    }
});
